import React from "react"
import styled from "styled-components"
import SwiperCore, { Pagination, Autoplay, Navigation } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import Section from "./Section"
import Container from "./Container"
import { brandTertiaryTrans10Theme } from "../../theme"
import TextWrapper from "./TextWrapper"
import H2 from "../typography/H2"
import ImageWrapper from "./ImageWrapper"
import P from "../typography/P"
import H4 from "../typography/H4"
import InternalButton from "./InternalButton"
import { brandLightAccentColor } from "../../theme"
import ConniePonturoImage from "../staticQuery/testimonials/ConniePonturoImage"

import "swiper/swiper.min.css"
import MaryleeMundellImage from "../staticQuery/testimonials/MaryleeMundellImage"
import ScottHernbergImage from "../staticQuery/testimonials/ScottHernbergImage"
import TillyWrightImage from "../staticQuery/testimonials/TillyWrightImage"
import UncleAndysImage from "../staticQuery/testimonials/UncleAndysImage"

SwiperCore.use([Pagination, Autoplay, Navigation])

const slides = [
  {
    name: "Conni Ponturo",
    title: "Absolute Pilates Upstairs",
    testimonial:
      "I was speaking at a convention with 16,000 attendees and had people signing up while I was talking...game changer.",
    image: <ConniePonturoImage />,
  },
  {
    name: "Dr. Marylee Mundell",
    title: "Pediatric Care Group, P.C.",
    testimonial:
      "Switching to MindMe from a leading email only program gave us so many more options to connect with patients.  Their combination of email, text messaging, landing pages and marketing automation is a game changer!",
    image: <MaryleeMundellImage />,
  },
  {
    name: "Andy Nannoshi",
    title: "Uncle Andy’s Pizza",
    testimonial:
      "When we needed a proven way to get more walk-in and repeat business, we turned to MindMe.  We began promoting our e-club using their easy-to-use mobile marketing solution and the results came pouring in!",
    image: <UncleAndysImage />,
  },
  {
    name: "Tilly Wright",
    title: "Content & SEO Ninja",
    testimonial:
      "Creating e-newsletters with MindMe is easy with drag and drop tools. I can embed social media links, logos and promotions to catch each visitor’s attention. Everything is mobile friendly!",
    image: <TillyWrightImage />,
  },
  {
    name: "Dr. Scott Hernberg",
    title: "Tomorrow's Wellness Center",
    testimonial:
      "An amazing all-in-one marketing solution!  We’ve seen huge growth in our business.  The ROI has been strong.  We can generate lots of new leads off of a single campaign.",
    image: <ScottHernbergImage />,
  },
]

const Testimonials = () => (
  <Section
    className="testimonial-wrapper-padding"
    style={{ backgroundColor: brandLightAccentColor }}
  >
    <CustomContainer className="testimonial-header-container">
      <H2 className="testimonial-header">See What Others Are Saying</H2>
    </CustomContainer>
    <ContainerPadding0>
      <Swiper
        slidesPerView={1}
        navigation
        autoplay={{ delay: 5000 }}
        // disableOnInteraction={true}
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
        }}
        pagination={{
          clickable: true,
          type: "bullets",
          el: ".swiper-pagination",
        }}
      >
        {slides.map(({ name, title, testimonial, image }) => (
          <SwiperSlide>
            <ContainerPadding0 alignItems="center">
              <TextWrapper imageLeft long className="testimonial-text-wrapper">
                <CustomText>{testimonial}</CustomText>
                <TestimonialName>{name}</TestimonialName>
                <TestimonialDescription>{title}</TestimonialDescription>
              </TextWrapper>
              <CustomImageWrapper
                className="custom-image-height"
                imageLeft
                short
              >
                {image}
              </CustomImageWrapper>
            </ContainerPadding0>
          </SwiperSlide>
        ))}
      </Swiper>
    </ContainerPadding0>
  </Section>
)

export default Testimonials

const ContainerPadding0 = styled(Container)`
  ${({ theme }) => theme.se`
   padding: 0;
   flex-direction: column;
   align-items: flex-start;
   .swiper-container {
      width: 100%;
    }
 `}
  ${({ theme }) => theme.desktop`
   flex-direction: row;
   align-items: center;
   
 `}
`

const CustomContainer = styled(Container)`
  ${({ theme }) => theme.se`
   padding: 0;
   display: flex;
  //  justify-content: center;
  .testimonial-header{
    font-size: 35px;
  }
 `}
  ${({ theme }) => theme.tablet`
   &.testimonial-header-container{
   justify-content: center;
  }
 `}
  ${({ theme }) => theme.desktop`
   justify-content: center;
   .testimonial-header{
   margin-bottom: 0px;
  }
 `}
`
const CustomImageWrapper = styled(ImageWrapper)`
  ${({ theme }) => theme.tablet`
    width: 50%;
  &.custom-image-height{
     margin: 20px auto;
    }
 `}
  ${({ theme }) => theme.desktop`
    width:  ${({ half }) => (half ? "48%" : "35%")};
    &.custom-image-height{
      max-height: 360px;
      max-width: 360px;
    }
 `}
`

const CustomText = styled(P)`
  ${({ theme }) => theme.desktop`
    font-size: 26px;
    font-weight: 300;
    margin-bottom: 40px;
   
  `}
`

const TestimonialName = styled(H4)`
  ${({ theme }) => theme.desktop`
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 0px;
  `}
`

const TestimonialDescription = styled(P)`
  ${({ theme }) => theme.desktop`
      font-size: 16px;
   
    `}
`
